// A grade da tabela vive aqui porque o cabeçalho da lista e a linha precisam
// concordar coluna a coluna. Definida em dois lugares, ela diverge no primeiro
// ajuste — e o cabeçalho passa a apontar para a coluna errada.
//
// Da esquerda pra direita: expandir · status · destinatário · modelo · mensagem
// (a única elástica) · ações · envio · reenviar/apagar.
// A coluna de status tem 130px porque "Não quis receber" e "Não identificado"
// são os rótulos mais longos e, com ícone e respiro, pedem ~126px. Apertar aqui
// faz o texto invadir o telefone — e a largura sai da coluna elástica, que tem
// de sobra.
// A coluna de envio tem 84px porque, além do horário, carrega o ⓘ do custo do
// envio (20px + respiro) — a largura sai da coluna elástica da mensagem.
export const GRADE_COLUNAS = '24px 130px 128px 56px minmax(0,1fr) 116px 84px 60px'
